import { ParserVars } from '../types/Run';

/**
 * Return a ParserVars blob with `atmosphere.force_synthetic_dp` set,
 * preserving every other sub-object (catesby/traverse/imu/...) already
 * stored at that scope.
 *
 * Lives apart from ForceSyntheticDpControl because callers that only write
 * the flag — a session options panel, a run health page — should not have to
 * import a component to do it, and a file mixing the two cannot hot-reload.
 */
export function withForceSyntheticDp(
  pv: ParserVars | null | undefined,
  next: boolean | null,
): ParserVars {
  const atmosphere = next == null
    ? null
    : { ...(pv?.atmosphere ?? {}), force_synthetic_dp: next };
  return { ...(pv ?? {}), version: pv?.version ?? 1, atmosphere };
}
